import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { PaymentGatewayTopUp } from "./PaymentGatewayTopUpAPI";

const initialState = {
    data: [],
    loading: false,
    error: null,
};

export const paymentGatewayTopUpAsync = createAsyncThunk(
    "paymentGatewayTopUP/add",
    async (uuid) => {
        try {
            const data = await PaymentGatewayTopUp(uuid);
            // console.log("data in slice", data);
            return data;
        } catch (error) {
            // console.log("errorL :", error);
            // return rejectWithValue(error.message);
        }
    }
);

const PaymentGatewayTopUpSlice = createSlice({
    name: "paymentGatewayTopUp",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(paymentGatewayTopUpAsync.fulfilled, (state, action) => {
                state.data?.push(action.payload);
            })
            .addCase(paymentGatewayTopUpAsync.rejected, (state, action) => {
                state.error = action.payload;
            });
    },
});
// export const selectEmployerLogo = (state) => state.employerLogo.data;

export default PaymentGatewayTopUpSlice.reducer;
